import { createPortal } from "react-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./EditAbsent.css";

const mergeDateTime = (date, time) => {
  if (!date || !time) return null;
  const [h, m] = time.split(":").map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  const d = new Date(date);
  d.setHours(h, m, 0, 0);
  return d;
};

const formatDuration = (ms) => {
  const totalMin = Math.round(ms / 60000);
  return `${Math.floor(totalMin / 60)} jam ${totalMin % 60} menit`;
};

// kalender dirender di body supaya tidak terpotong overflow:hidden panel
const PopperPortal = ({ children }) => createPortal(children, document.body);

const Field = ({ label, children }) => (
  <label className="ea-field">
    <span className="ea-label">{label}</span>
    {children}
  </label>
);

const EditAbsent = (props) => {
  const {
    setClockInValueEdit,
    setClockOutValueEdit,
    clockInValue,
    clockOutValue,
    onChange,
    selected,
    selectedIn,
    onChangeIn,
  } = props;

  const hasDate = !!onChangeIn && !!onChange;

  const start = hasDate ? mergeDateTime(selectedIn, clockInValue) : null;
  const end = hasDate ? mergeDateTime(selected, clockOutValue) : null;
  const diff = start && end ? end - start : null;

  return (
    <div className="ea-card">
      <div className="ea-grid">
        <section className="ea-col">
          <div className="ea-col-title ea-col-title--in">
            <i /> Masuk
          </div>
          {hasDate ? (
            <Field label="Tanggal">
              <DatePicker
                selected={selectedIn}
                onChange={onChangeIn}
                dateFormat="EEE, dd MMM yyyy"
                className="ea-input"
                popperContainer={PopperPortal}
              />
            </Field>
          ) : null}
          <Field label="Jam">
            <input
              type="time"
              className="ea-input"
              value={clockInValue || ""}
              onChange={(e) => setClockInValueEdit(e.target.value)}
            />
          </Field>
        </section>

        <section className="ea-col">
          <div className="ea-col-title ea-col-title--out">
            <i /> Keluar
          </div>
          {hasDate ? (
            <Field label="Tanggal">
              <DatePicker
                selected={selected}
                onChange={onChange}
                dateFormat="EEE, dd MMM yyyy"
                className="ea-input"
                popperContainer={PopperPortal}
              />
            </Field>
          ) : null}
          <Field label="Jam">
            <input
              type="time"
              className="ea-input"
              value={clockOutValue || ""}
              onChange={(e) => setClockOutValueEdit(e.target.value)}
            />
          </Field>
        </section>
      </div>

      {diff !== null ? (
        diff < 0 ? (
          <div className="ea-summary ea-summary--error">
            Jam keluar lebih awal dari jam masuk, cek lagi tanggal dan jamnya.
          </div>
        ) : (
          <div className="ea-summary">Durasi: {formatDuration(diff)}</div>
        )
      ) : null}
    </div>
  );
};

export default EditAbsent;
